module.exports = __webpack_public_path__ + "static/media/slideshow1.703e490c.jpg";